import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import './HelpPage.css';

function HtbSection(props) {
  var isDark = props.isDark;
  return (
    <div className={'help-reveal help-fade-up help-delay-' + (props.delay || '1') + ' help-section-card'} style={{
      backgroundColor: isDark ? '#141414' : '#fff',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'),
      borderRadius: '16px',
      padding: '28px',
      marginBottom: '20px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
    }}>
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div style={{
          width: '40px', height: '40px', borderRadius: '10px',
          backgroundColor: 'rgba(201,168,76,0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0
        }}>
          <i className={'fa fa-' + props.icon} style={{ color: '#c9a84c', fontSize: '16px' }} />
        </div>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>
          {props.title}
        </h2>
      </div>
      <div style={{ color: isDark ? '#d1d5db' : '#4b5563', fontSize: '15px', lineHeight: '1.7' }}>
        {props.children}
      </div>
    </div>
  );
}

function HtbScreenshot(props) {
  var isDark = props.isDark;
  var isMobile = window.innerWidth < 768;
  var src = props.src;
  if (isMobile && isDark) {
    src = src.replace(/\.jpg$/, '-mobile-dark.jpg');
  } else if (isMobile) {
    src = src.replace(/\.jpg$/, '-mobile.jpg');
  } else if (isDark) {
    src = src.replace(/\.jpg$/, '-dark.jpg');
  }
  return (
    <div className="help-screenshot" style={{
      marginTop: '16px',
      marginBottom: '8px',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid ' + (isDark ? '#2a2a2a' : '#e2e2e2'),
      boxShadow: '0 4px 20px rgba(0,0,0,' + (isDark ? '0.3' : '0.08') + ')'
    }}>
      <img src={src} alt={props.alt || ''} style={{
        width: '100%', display: 'block'
      }} />
    </div>
  );
}

class HowToBuy extends Component {
  constructor(props) {
    super(props);
    this.state = { isDark: document.documentElement.classList.contains('tw-dark'), showScrollTop: false };
    this._observer = null;
    this._darkObserver = null;
    this._handleScroll = this._handleScroll.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    var els = document.querySelectorAll('.help-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('help-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function(el) { observer.observe(el); });
      this._observer = observer;
    } else {
      els.forEach(function(el) { el.classList.add('help-visible'); });
    }

    window.addEventListener('scroll', this._handleScroll);
    var self = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== self.state.isDark) self.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._observer) this._observer.disconnect();
    if (this._darkObserver) this._darkObserver.disconnect();
    window.removeEventListener('scroll', this._handleScroll);
  }

  _handleScroll() {
    var show = window.scrollY > 400;
    if (show !== this.state.showScrollTop) this.setState({ showScrollTop: show });
  }

  render() {
    var isDark = this.state.isDark;

    return (
      <div style={{ backgroundColor: isDark ? '#111' : '#f9fafb', minHeight: '100vh' }}>
        <Helmet><title>How to Buy | Primal Market</title></Helmet>

        {/* Hero */}
        <div style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
          padding: '60px 20px 48px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              width: '56px', height: '56px', borderRadius: '16px',
              backgroundColor: 'rgba(201,168,76,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <i className="fa fa-shopping-bag" style={{ color: '#c9a84c', fontSize: '24px' }} />
            </div>
            <h1 style={{ color: '#fff', fontSize: '32px', fontWeight: '700', marginBottom: '12px', marginTop: 0 }}>
              How to Buy
            </h1>
            <p style={{ color: '#9ca3af', fontSize: '16px', maxWidth: '500px', margin: '0 auto', lineHeight: '1.6' }}>
              Find the cards you need and checkout in minutes.
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ maxWidth: '720px', margin: '0 auto', padding: '32px 16px 64px' }}>

          <HtbSection isDark={isDark} icon="search" title="Step 1: Find Your Cards" delay="1">
            <p style={{ margin: '0 0 12px' }}>
              Use the <strong>Browse</strong> page to explore all available cards. You can:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Search by name</strong> — Type any card name in the search bar</li>
              <li style={{ marginBottom: '6px' }}><strong>Filter by set</strong> — Browse cards from a specific set</li>
              <li style={{ marginBottom: '6px' }}><strong>Filter by condition</strong> — Near Mint, Lightly Played, etc.</li>
              <li style={{ marginBottom: '6px' }}><strong>Sort by price</strong> — Find the best deals quickly</li>
            </ul>
            <p style={{ margin: 0 }}>
              Click on any card to see its detail page with all available listings, price history, and market price.
            </p>
            <HtbScreenshot isDark={isDark} src="/help/browse-cards.jpg" alt="Browse page with filters" />
          </HtbSection>

          <HtbSection isDark={isDark} icon="cart-plus" title="Step 2: Add to Cart" delay="2">
            <p style={{ margin: '0 0 12px' }}>
              Found a card you want? Add it to your cart from the card detail page. You can:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Buy from any seller</strong> — Choose from multiple listings at different prices and conditions</li>
              <li style={{ marginBottom: '6px' }}><strong>Add multiple cards</strong> — Build your cart from different sellers</li>
              <li style={{ marginBottom: '6px' }}><strong>Make an offer</strong> — If the seller accepts offers, negotiate a better price</li>
            </ul>
            <p style={{ margin: 0 }}>
              Your cart groups items by seller so you can see shipping costs clearly.
            </p>
            <HtbScreenshot isDark={isDark} src="/help/card-detail.jpg" alt="Card detail page with Add to Cart" />
          </HtbSection>

          <HtbSection isDark={isDark} icon="credit-card" title="Step 3: Checkout" delay="3">
            <p style={{ margin: '0 0 12px' }}>
              When you're ready to buy, head to your cart and click <strong>Checkout</strong>. We accept:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Credit &amp; Debit Cards</strong> — Powered by Stripe</li>
              <li style={{ marginBottom: '6px' }}><strong>PayPal</strong> — Pay with your PayPal account</li>
            </ul>
            <p style={{ margin: 0 }}>
              Enter your shipping address, review the order summary (items, shipping, tax), and confirm your purchase. You'll receive an email confirmation with your order details.
            </p>
            <HtbScreenshot isDark={isDark} src="/help/checkout.jpg" alt="Checkout page with payment methods" />
          </HtbSection>

          <HtbSection isDark={isDark} icon="truck" title="Step 4: Track Your Order" delay="4">
            <p style={{ margin: '0 0 12px' }}>
              After your purchase, track your order from the <strong>Order History</strong> page:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Order status</strong> — See real-time progress (Paid → Shipped → Delivered)</li>
              <li style={{ marginBottom: '6px' }}><strong>Tracking number</strong> — Click to track your package with the carrier</li>
              <li style={{ marginBottom: '6px' }}><strong>Message seller</strong> — Contact the seller directly if you have questions</li>
            </ul>
            <HtbScreenshot isDark={isDark} src="/help/order-history.jpg" alt="Order history with tracking status" />
          </HtbSection>

          <HtbSection isDark={isDark} icon="shield" title="Buyer Protection" delay="5">
            <p style={{ margin: '0 0 12px' }}>
              Every purchase on Primal Market is protected by our <strong>14-day buyer protection</strong> program:
            </p>
            <ul style={{ margin: '0 0 12px', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '6px' }}><strong>Funds held in escrow</strong> — Your payment is held securely until you receive your card</li>
              <li style={{ marginBottom: '6px' }}><strong>Confirm receipt</strong> — Once you receive and inspect your card, confirm delivery to release payment to the seller</li>
              <li style={{ marginBottom: '6px' }}><strong>Open a dispute</strong> — If something is wrong (item not received, not as described, damaged), open a dispute within 14 days</li>
              <li style={{ marginBottom: '6px' }}><strong>Auto-release</strong> — If you don't take action within 14 days of shipping, funds are automatically released to the seller</li>
            </ul>
            <div style={{
              backgroundColor: isDark ? '#1a1a1a' : '#f0f7f0',
              borderRadius: '10px', padding: '14px 18px',
              border: '1px solid ' + (isDark ? '#2a2a2a' : '#d1e7d1'),
              marginTop: '12px'
            }}>
              <i className="fa fa-check-circle" style={{ color: '#22c55e', marginRight: '8px' }} />
              <span style={{ fontSize: '14px' }}>Your money is always protected until you're satisfied with your purchase.</span>
            </div>
          </HtbSection>

          {/* CTA */}
          <div className="help-reveal help-fade-up help-delay-6" style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/browse" className="tw-no-underline help-cta-btn" style={{
              display: 'inline-block', backgroundColor: '#c9a84c', color: '#000',
              fontWeight: '600', fontSize: '15px', padding: '12px 32px',
              borderRadius: '10px', textDecoration: 'none'
            }}>
              Browse Cards
            </Link>
          </div>
        </div>

        {this.state.showScrollTop && (
          <button
            onClick={function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="tw-fixed tw-bottom-6 tw-right-6 tw-w-10 tw-h-10 tw-rounded-full tw-bg-brand-gold tw-text-black tw-border-0 tw-cursor-pointer tw-z-40 tw-flex tw-items-center tw-justify-center"
            style={{ boxShadow: '0 4px 16px rgba(201, 168, 76, 0.3)' }}
            aria-label="Scroll to top"
          >
            <svg className="tw-w-6 tw-h-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    );
  }
}

export default HowToBuy;
